module.exports = __webpack_public_path__ + "assets/img/632221.40244153.png";